// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__KNQRJ","author":"Table_author__zWIlN","authorImage":"Table_authorImage__2SYJW","unreadRow":"Table_unreadRow__2PW0s"};